import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "src/envs/environnement";

export interface Menu {
    id: string;
    libelle: string;
    description: string;
    icon: string;
    route: string;
    isMain:boolean;
    permission:string;
    sousMenus: string;
    sousMenusIcon: string;
    sousMenusRouter: string;
    roles: string[];
}

@Injectable({
    providedIn: 'root'
})
export class MyMenuService {
    private apiUrl = environment.baseUrl+"/menu";
    private token=sessionStorage.getItem("token")
    constructor(private http: HttpClient) {}

    // Récupérer tous les menus
    getMenus(): Observable<Menu[]> {
        return this.http.get<Menu[]>(this.apiUrl);
    }

    // Récupérer un menu par son ID
    getMenuById(id: string): Observable<Menu[]> {

        return this.http.get<Menu[]>(`${this.apiUrl}/${id}`,{withCredentials:true});
    }

    // Ajouter un menu
    addMenu(menu: Menu): Observable<Menu> {
        return this.http.post<Menu>(this.apiUrl, menu);
    }

    // Modifier un menu
    updateMenu(id: string, menu: Menu): Observable<Menu> {
        return this.http.put<Menu>(`${this.apiUrl}/${id}`, menu);
    }

    // Supprimer un menu
    deleteMenu(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
